<template>
    <div style="width: 100%;">
        <treeselect 
            v-model="selectedSites"
            class="site-multi-select"
            :multiple="true"
            :clearable="true"
            :searchable="true"
            :max-height="300"
            :limit="3"
            :rtl="false"
            :options="siteOptions"
            @input="onInput"
            :disabled="disabled"
            :placeholder="this.$t('selectLocation')"
        />
    </div>
</template>

<script>

import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
//import _ from 'lodash';

export default {
    name: 'SiteMultiSelectTree',
    components: {
        Treeselect
    },
    props: {
        givenSites: {
            type: Array,
            default() {
                return [];
            }
        },
        classes: {
            type: Object,
            default() {
                return {};
            }
        },
        givenSelectedSites: {
            type: Array,
            default() {
                return [];
            }
        },
        disabled: {
            type: Boolean,
            default() {
                return false;
            }
        },
    },
    data() {
        return {
            siteOptions: [],
            selectedSites: []
        };
    },
    methods: {
        onInput(value) {
            
            this.selectedSites = value;
            this.$emit('oninput', value);
        },
        selectAll() {
        }
    },
    computed: {
    },
    watch: {
        givenSelectedSites(newVal) {
            this.selectedSites = newVal;
        }
    },
    created() {
        this.siteOptions = [{id:"All", label:this.$t('selectAll'), children:this.givenSites, isDefaultExpanded:true}];
        this.selectedSites = this.givenSelectedSites;
    }
};
</script>

<style lang="scss">
.site-multi-select {
    .vue-treeselect__menu-container {
        position: relative !important;
    }
    .vue-treeselect__menu {
        position: relative !important;
    }
}
</style>

<i18n src="../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "selectAll": "Hepsini Seç",
            "selectLocation": "Lokasyon Seçin"
        },
        "en": {
            "selectAll": "Select All",
            "selectLocation": "Select Location"
        }
    }
</i18n>


// WEBPACK FOOTER //
// src/components/SiteMultiSelectTree.vue